const CUSTOM_EVENT_TYPE = {
  NOTE: "note",
  VACATION: "vacation",
};

export default CUSTOM_EVENT_TYPE;
